import { makeVar } from "@apollo/client";
import { District, AllFlyerFilters, Flyer, Subscription, Facets } from "@/graphql/types";
import { PaginationOptions } from "../types/Pagination";

export const districtVar = makeVar<District | null>(null);

export const allFlyersVar = makeVar<{
  items: Flyer[],
  pagination: PaginationOptions
} | null>(null);

export const flyerboardAllFiltersVar = makeVar<AllFlyerFilters | null>(null);

export const showCommunityDisclaimerVar = makeVar<boolean>(true);

export const subscriptionsVar = makeVar<Subscription[]>([]);

export const allSubscriptionsVar = makeVar<Subscription[]>([]);

export const filterFacetsVar = makeVar<Facets>({
  categories: [],
  gradesOrAges: []
});

export const flyerboardActiveFiltersVar = makeVar<{
  grades_age: string[],
  types: string[],
}>({
  grades_age: [],
  types: [],
})

export const flyerVar = makeVar<Flyer | null>(null);

export const userInformationVar = makeVar<{
  email: string;
  firstName: string;
  lastName: string;
  id: number;
} | null>(null);

export const flyerboardFlyersAmountVar = makeVar<number>(0);

export const openLoginDrawerVar = makeVar<boolean>(false);

export const showMagicLinkSuccessVar = makeVar<boolean>(false);

export const loginEmailVar = makeVar<string>('')
